// src/components/hub/work/TaskSlideOut.js
import React from "react";
import WorkPanel from "./WorkPanel";

const TaskSlideOut = ({
  selectedTaskId,
  detail,
  recurring,
  onClose,
  onClientClick,
  onPositionClick,
  onTitleChange,
  onDueDateChange,
  onAssigneeClick,
  onDescriptionChange,
  onTaskUpdated,
  onArchive,
  showError,
  showSuccess,
  onPriorityChange,
  priorityOptions,
  onServiceChange,
  serviceOptions,
  subtaskRevision,
  workTypeOptions = [],
  onWorkTypeChange,
  onClientChange,
  onDelete,
}) => {
  if (!selectedTaskId) return null;

  return (
    <div className="fixed inset-0 z-[60] flex justify-end">
      <div className="absolute inset-0 bg-black/30" onClick={onClose} />
      <div
        className="relative w-full max-w-[1000px] bg-white dark:bg-gray-900 shadow-xl flex flex-col pt-6"
        style={{ height: "100vh" }}
      >
        {/* Thin loading bar — pulses during any load and fades when done
            (Item 3). Shown for both the first-load skeleton and silent
            refreshes while WorkPanel stays mounted. */}
        <div className={`h-0.5 w-full transition-opacity ${detail.loading ? "opacity-100" : "opacity-0"}`}>
          <div className="h-full bg-blue-500 animate-pulse rounded-full" />
        </div>
        {/* Skeleton only on the very first load (no data yet). Once data
            exists, keep WorkPanel mounted (frozen) during a silent refresh
            so the slider never vanishes. An error only shows when there's no
            data to fall back on. */}
        {detail.error && !detail.data ? (
          <div className="p-6">
            <p className="text-sm text-red-600 dark:text-red-400 font-medium">
              Failed to load task
            </p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
              {detail.error}
            </p>
          </div>
        ) : detail.loading && !detail.data ? (
          <div className="p-6 animate-pulse">
            <div className="h-5 w-64 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
            <div className="h-4 w-48 bg-gray-200 dark:bg-gray-700 rounded mb-6" />
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="h-16 bg-gray-100 dark:bg-gray-800 rounded"
                />
              ))}
            </div>
          </div>
        ) : (
          <WorkPanel
            detail={detail.data}
            taskId={selectedTaskId}
            recurring={recurring}
            onClose={onClose}
            onClientClick={onClientClick}
            onPositionClick={onPositionClick}
            onTitleChange={onTitleChange}
            onDueDateChange={onDueDateChange}
            onAssigneeClick={onAssigneeClick}
            onDescriptionChange={onDescriptionChange}
            onTaskUpdated={onTaskUpdated}
            onArchive={onArchive}
            showError={showError}
            showSuccess={showSuccess}
            onPriorityChange={onPriorityChange}
            priorityOptions={priorityOptions}
            onServiceChange={onServiceChange}
            serviceOptions={serviceOptions}
            subtaskRevision={subtaskRevision}
            workTypeOptions={workTypeOptions}
            onWorkTypeChange={onWorkTypeChange}
            onClientChange={onClientChange}
            onDelete={onDelete}
          />
        )}
      </div>
    </div>
  );
};

export default TaskSlideOut;
